/**
 * Sheet-size presets shown in the Settings panel dropdown.
 * Source of truth for the dimensions: pm/decisions/default-sheet-sizes.md
 * (Alex, Sprint 0).
 */

export interface SheetPreset {
  id: string;
  label: string;
  width: number;
  height: number;
}

export const SHEET_PRESETS: readonly SheetPreset[] = [
  { id: "standard", label: "Standard 8×4 (2440×1220)", width: 2440, height: 1220 },
  { id: "oversize", label: "Oversize (2800×2070)", width: 2800, height: 2070 },
  { id: "half", label: "Half sheet (1830×1220)", width: 1830, height: 1220 },
] as const;

export const CUSTOM_PRESET_ID = "custom";

/** Find the preset that matches these exact dimensions, else CUSTOM. */
export function matchPreset(width: number, height: number): string {
  const match = SHEET_PRESETS.find(
    (p) => p.width === width && p.height === height,
  );
  return match?.id ?? CUSTOM_PRESET_ID;
}
